import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const SearchPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SearchPage" */ './SearchPage.tsx'))
			.ConfluenceSearchPage,
});
